// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.individual-filter-contacts-wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  padding: 25px 20px;
  margin: 20px auto; 
  gap: 20px;
  background-color: #fff; 
  border: 1px solid #ddd;
  border-radius: 8px; 
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }

  .individual-input-filed {
    display: flex;
    flex-direction: column;
    width: 25%;
  }
  
  .individual-input-filed label {
    font-weight: bold;
    margin-bottom: 8px;
    text-align: left;
  }
  
  .individual-input-filed select {
    padding: 10px 5px;
    font-size: 16px;
    border: 1px solid #f2f2f2;
    border-radius: 4px;
    width: 100%; 
    box-sizing: border-box;
    margin-bottom: 10px;
  }

  .individual-input-filed input {
    padding: 10px 5px;
    font-size: 16px;
    border: 1px solid #f2f2f2;
    background: #fff;
    border-radius: 4px;
    width: 100%; 
    box-sizing: border-box;
    /* margin-bottom: 10px; */
    color: #373737;
  }
  
  .individual-input-filed .mobile-number-wrapper {
    display: flex;
    align-items: center;
  }
  
  .individual-input-filed .prefix {
    background-color: #f2f2f2;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px 0 0 4px;
    font-size: 16px;
    font-weight: bold;
    color: #333;
    text-align: center;
    height: 100%;
    /* margin-bottom: 10px; */
  }
  
  .individual-input-filed .mobile-number {
    flex-grow: 1;
    border-radius: 0 4px 4px 0;
    margin-left: -1px; 
  }
  

  .individual-form-actions {
    display: flex;
    gap: 10px;
    align-items: center;
    padding: 15px 0 0;
  }
  
  .individual-form-actions .btn {
    padding: 8px 16px;
    font-size: 16px;
    color: #fff;
    background-color: #007bff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .individual-form-actions .submit-btn {
    background-color: #44a67e;
    border-color: #44a67e;
  }

  .individual-form-actions .allContacts-btn {
    background-color: #373435;
    color: #ffcc29;
    border-color: #44a67e;
  }
  
  .individual-form-actions .submit-btn:hover {
    background-color: #44a67e;
    border-color: #44a67e;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
  }

  .individual-form-actions .allContacts-btn:hover {
    background-color: #373435;
    border-color: #373435;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
  }

  /* search filter */
  .senderid-search-filter {
    margin: 20px auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: end;
    align-items: center;
    gap: 20px;
  }
  
  .senderid-search-filter input {
    width: 250px;
    padding: 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
  }

  /* ==========Message Note Style=========  */
  .individual-input-filed .input-alert-combine {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  
  .individual-input-filed small {
    /* color: #373435;
    font-size: 12px;
    text-align: start; */
    font-size: 13px !important;
    font-style: italic;
    color: #44a67e;
    text-align: start;
    font-weight: 550;
  }

  /* Table structure */
  .individual-contacts-table-container p {
    text-align: left;
    color: #373435;
  }

  .individual-contacts-table {
    width: 100%;
    border-collapse: collapse;
    text-align: left;
  }
  
  .individual-contacts-table th,
  .individual-contacts-table td {
    text-align: left;
    padding: 10px;
    border: 1px solid #ddd;
    color: #373435;
  }
  
  .individual-contacts-table th {
    background-color: #f2f2f2;
    font-weight: bold;
    color: #373435;
    text-transform: uppercase;
    text-align: left;
  }
  
  .individual-contacts-table tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  
  .individual-contacts-table tr:hover {
    background-color: #f1f1f1;
  }

  /* response message */
  .individual-contact-response {
    background-color: #28a745;
    color: #fff;
    border-radius: 5px;
    margin: 10px auto;
  }

  .individual-contact-response p {
    color: #fff;
    margin-top: 10px;
    padding: 10px;
    text-align: left;
  }

  .individual-contact-buttons-wrap {
    display: flex;
    justify-content: space-between;
    margin: 20px auto;
  }

  .individual-contact-buttons-wrap .download-blacklist-button {
    background-color: #373435;
    color: #ffcc29;
    padding: 10px 12px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }

  .individual-contact-buttons-wrap .delete-selected-button {
    background: #fb3d4e;
    color: #fff;
    padding: 10px 12px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }

  .wrap-individual-contacts {
    margin: 0 40px;
  } `, "",{"version":3,"sources":["webpack://./src/components/IndividualContacts/IndividualContacts.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;EACT,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,0BAA0B;IAC1B,iBAAiB;EACnB;;;EAGA;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,qFAAqF;EACvF;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,qFAAqF;EACvF;;EAEA,kBAAkB;EAClB;IACE,iBAAiB;IACjB,aAAa;IACb,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB;;EAEA,2CAA2C;EAC3C;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE;;wBAEoB;IACpB,0BAA0B;IAC1B,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA,oBAAoB;EACpB;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;;IAEE,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,qBAAqB;EACrB;IACE,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB","sourcesContent":[".individual-filter-contacts-wrap {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 25px 20px;\r\n  margin: 20px auto; \r\n  gap: 20px;\r\n  background-color: #fff; \r\n  border: 1px solid #ddd;\r\n  border-radius: 8px; \r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n  }\r\n\r\n  .individual-input-filed {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 25%;\r\n  }\r\n  \r\n  .individual-input-filed label {\r\n    font-weight: bold;\r\n    margin-bottom: 8px;\r\n    text-align: left;\r\n  }\r\n  \r\n  .individual-input-filed select {\r\n    padding: 10px 5px;\r\n    font-size: 16px;\r\n    border: 1px solid #f2f2f2;\r\n    border-radius: 4px;\r\n    width: 100%; \r\n    box-sizing: border-box;\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  .individual-input-filed input {\r\n    padding: 10px 5px;\r\n    font-size: 16px;\r\n    border: 1px solid #f2f2f2;\r\n    background: #fff;\r\n    border-radius: 4px;\r\n    width: 100%; \r\n    box-sizing: border-box;\r\n    /* margin-bottom: 10px; */\r\n    color: #373737;\r\n  }\r\n  \r\n  .individual-input-filed .mobile-number-wrapper {\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n  \r\n  .individual-input-filed .prefix {\r\n    background-color: #f2f2f2;\r\n    padding: 10px;\r\n    border: 1px solid #ddd;\r\n    border-radius: 4px 0 0 4px;\r\n    font-size: 16px;\r\n    font-weight: bold;\r\n    color: #333;\r\n    text-align: center;\r\n    height: 100%;\r\n    /* margin-bottom: 10px; */\r\n  }\r\n  \r\n  .individual-input-filed .mobile-number {\r\n    flex-grow: 1;\r\n    border-radius: 0 4px 4px 0;\r\n    margin-left: -1px; \r\n  }\r\n  \r\n\r\n  .individual-form-actions {\r\n    display: flex;\r\n    gap: 10px;\r\n    align-items: center;\r\n    padding: 15px 0 0;\r\n  }\r\n  \r\n  .individual-form-actions .btn {\r\n    padding: 8px 16px;\r\n    font-size: 16px;\r\n    color: #fff;\r\n    background-color: #007bff;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .individual-form-actions .submit-btn {\r\n    background-color: #44a67e;\r\n    border-color: #44a67e;\r\n  }\r\n\r\n  .individual-form-actions .allContacts-btn {\r\n    background-color: #373435;\r\n    color: #ffcc29;\r\n    border-color: #44a67e;\r\n  }\r\n  \r\n  .individual-form-actions .submit-btn:hover {\r\n    background-color: #44a67e;\r\n    border-color: #44a67e;\r\n    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;\r\n  }\r\n\r\n  .individual-form-actions .allContacts-btn:hover {\r\n    background-color: #373435;\r\n    border-color: #373435;\r\n    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;\r\n  }\r\n\r\n  /* search filter */\r\n  .senderid-search-filter {\r\n    margin: 20px auto;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    justify-content: end;\r\n    align-items: center;\r\n    gap: 20px;\r\n  }\r\n  \r\n  .senderid-search-filter input {\r\n    width: 250px;\r\n    padding: 12px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    font-size: 14px;\r\n  }\r\n\r\n  /* ==========Message Note Style=========  */\r\n  .individual-input-filed .input-alert-combine {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%;\r\n  }\r\n  \r\n  .individual-input-filed small {\r\n    /* color: #373435;\r\n    font-size: 12px;\r\n    text-align: start; */\r\n    font-size: 13px !important;\r\n    font-style: italic;\r\n    color: #44a67e;\r\n    text-align: start;\r\n    font-weight: 550;\r\n  }\r\n\r\n  /* Table structure */\r\n  .individual-contacts-table-container p {\r\n    text-align: left;\r\n    color: #373435;\r\n  }\r\n\r\n  .individual-contacts-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    text-align: left;\r\n  }\r\n  \r\n  .individual-contacts-table th,\r\n  .individual-contacts-table td {\r\n    text-align: left;\r\n    padding: 10px;\r\n    border: 1px solid #ddd;\r\n    color: #373435;\r\n  }\r\n  \r\n  .individual-contacts-table th {\r\n    background-color: #f2f2f2;\r\n    font-weight: bold;\r\n    color: #373435;\r\n    text-transform: uppercase;\r\n    text-align: left;\r\n  }\r\n  \r\n  .individual-contacts-table tr:nth-child(even) {\r\n    background-color: #f9f9f9;\r\n  }\r\n  \r\n  .individual-contacts-table tr:hover {\r\n    background-color: #f1f1f1;\r\n  }\r\n\r\n  /* response message */\r\n  .individual-contact-response {\r\n    background-color: #28a745;\r\n    color: #fff;\r\n    border-radius: 5px;\r\n    margin: 10px auto;\r\n  }\r\n\r\n  .individual-contact-response p {\r\n    color: #fff;\r\n    margin-top: 10px;\r\n    padding: 10px;\r\n    text-align: left;\r\n  }\r\n\r\n  .individual-contact-buttons-wrap {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin: 20px auto;\r\n  }\r\n\r\n  .individual-contact-buttons-wrap .download-blacklist-button {\r\n    background-color: #373435;\r\n    color: #ffcc29;\r\n    padding: 10px 12px;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .individual-contact-buttons-wrap .delete-selected-button {\r\n    background: #fb3d4e;\r\n    color: #fff;\r\n    padding: 10px 12px;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .wrap-individual-contacts {\r\n    margin: 0 40px;\r\n  } "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
